import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import WithEmbededWrapper from 'component/WithEmbededWrapper';

interface BreadcrumbItem {
  label: string;
  path?: string;
}
interface IProps {
  items: BreadcrumbItem[];
}

const BC: React.FC<IProps> = (props) => {
  return (
    <Breadcrumb separator=">" style={{ padding: '14px 0' }}>
      {props.items.map((item, i) => (
        <Breadcrumb.Item key={i}> {item.path ? <Link to={item.path}>{item.label}</Link> : item.label} </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default WithEmbededWrapper(BC);
